import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

const oddsBall = (props) => {

	let odds = parseInt(props.data,10);
	if(isNaN(odds)) odds = 0;
	if(odds <= 0) odds = '';
	if(odds > 100) odds = 100;

	return (
		<div className='oddsball'>
			<h6>Percentage (%)</h6>
			<p>Estimate <span className='percent'><input type='number' placeholder='0' value={odds} onChange={
				(event) => {props.rdxEditValue(props.id,event.target.value)}}/></span></p>
		</div>
	);

}

const mapDispatchToProps = dispatch => {
	return {
		rdxEditValue: (id,value) => 	dispatch(actions.editValue(id,value))
	};
}

export default connect(null, mapDispatchToProps)(oddsBall);


// WEBPACK FOOTER //
// ./src/UI/OddsBall.js